import { AfterViewInit, Component, ViewChild, ViewContainerRef } from "@angular/core";
import { ICellEditorAngularComp } from 'ag-grid-angular';


@Component({
    selector: 'numeric-cell',
    template: `<input type="tel" class="p-0" OnlyNumber="true" (keydown)="onKeyDown($event)" #input [(ngModel)]="value" style="width: 100%;height: 100%; border: 0;" autofocus>` // (keydown)="onKeyDown($event)"
})
export class NumericEditor implements ICellEditorAngularComp, AfterViewInit {
    private params: any;
    public value: number;
    private cancelBeforeStart: boolean = false;

    @ViewChild('input', { read: ViewContainerRef }) public input;


    agInit(params: any): void {
        this.params = params;
        if (this.params.charPress)
            this.value = this.params.charPress;
        else
            this.value = this.params.value;

        // only start edit if key pressed is a number, not a letter
        this.cancelBeforeStart = params.charPress && ('1234567890'.indexOf(params.charPress) < 0);
    }

    getValue(): any {
        if (this.value == null || this.value == undefined || this.value.toString() == "") {
            this.value = 0;
        }
        return this.value;
    }

    isCancelBeforeStart(): boolean {
        return this.cancelBeforeStart;
    }

    // will reject the number if it greater than 1,000,000
    // not very practical, but demonstrates the method.
    isCancelAfterEnd(): boolean {
        return this.value > 9999999;
    };

    onKeyDown(event): void {
        let inputChar = event.key;
        if (inputChar == '.') event.preventDefault();
        let numString = String(this.value);
        if (numString.length > 6) {
            if (event.key != 13 && event.key != 27 && String(event.key) != "Backspace") {
                event.preventDefault();
            }
        }
    }

    setCaret() {
        // let el = this.input.element.nativeElement;
        // let range = document.createRange();
        // let sel = window.getSelection();
        // range.setStart(el.childNodes[0], el.childNodes[0].length);
        // range.collapse(true);
        // sel.removeAllRanges();
        // sel.addRange(range);
        // el.focus();

        this.input.element.nativeElement.selectionStart = this.input.element.nativeElement.value.length;
        this.input.element.nativeElement.selectionEnd = this.input.element.nativeElement.value.length;
        this.input.element.nativeElement.focus();
    }
    

    // dont use afterGuiAttached for post gui events - hook into ngAfterViewInit instead for this
    ngAfterViewInit() {
        window.setTimeout(() => {
            // this.input.element.nativeElement.focus();
            this.setCaret();
        })
    }

    private getCharCodeFromEvent(event): any {
        event = event || window.event;
        return (typeof event.which == "undefined") ? event.keyCode : event.which;
    }

    private isCharNumeric(charStr): boolean {
        this.setCaret();
        return !!/\d/.test(charStr);
    }

    private isKeyPressedNumeric(event): boolean {
        const charCode = this.getCharCodeFromEvent(event);
        const charStr = event.key ? event.key : String.fromCharCode(charCode);
        return this.isCharNumeric(charStr);
    }
}
